import { getAccount } from '../../bom/user/getAccount';

/**
 * 内网检测
 */
const isIntranet = () => -1 < window.location.href.indexOf('//localhost:');

/**
 * 判断是否登录（存在同花顺账号）
 *
 * @returns {boolean} 如果已登录返回 true，否则返回 false
 * @example
 * ```ts
 * import { isLogin } from '@fu/matrix';
 *
 * if (isLogin()) {
 *   console.log('用户已登录');
 * } else {
 *   console.log('用户未登录');
 * }
 * ```
 */
export function isLogin(): boolean {
  return !!getAccount();
}

/**
 * 跳转客户端登录
 *
 * 跳转到客户端登录页面。
 *
 * 注意：该函数只负责跳转，不会监听登录状态。
 * 建议在页面中监听cookie变化或在页面重新获得焦点时检查登录状态。
 *
 * @example
 * ```ts
 * import { login } from '@fu/matrix';
 *
 * // 触发登录流程
 * login();
 * ```
 */
export function login(): void {
  try {
    // 检查是否在支持的环境中
    if (typeof window === 'undefined' || typeof window.location === 'undefined') {
      console.warn('login 函数只能在浏览器环境中使用');
      return;
    }

    const LOGIN_URL = 'http://eqhexin/changeUser';

    // 跳转到登录页面
    window.location.href = LOGIN_URL;
  } catch (error) {
    console.error('登录过程中发生错误:', error);
  }
}

/**
 * 校验登录，未登录则跳转登录（内网环境不触发跳转）
 *
 * @param cb - 登录成功后的回调函数
 * @returns {boolean} 如果已登录返回 true，否则返回 false
 * @example
 * ```ts
 * import { checkLogin } from '@fu/matrix';
 *
 * // 检查登录状态并执行回调
 * checkLogin(() => {
 *   console.log('用户已登录，执行后续操作');
 * });
 *
 * // 检查登录状态
 * const isLoggedIn = checkLogin();
 * if (isLoggedIn) {
 *   // 用户已登录的逻辑
 * }
 * ```
 */
export function checkLogin(cb?: () => void): boolean {
  if (!isLogin()) {
    // 非内网环境才触发登录跳转
    if (!isIntranet()) {
      login();
    }
    return false;
  } else {
    // 已登录，执行回调函数
    cb && cb();
    return true;
  }
}